<template>
  <ul class="orderInfo">
    <li>
      <div class="th">退款时间</div>
      <div class="td">{{ orderDeatilsData.refundMsg4OrderVo.refundTime||'--' }}</div>
    </li>
    <li>
      <div class="th">退款金额</div>
      <div class="td">
        {{ '-￥'+orderDeatilsData.refundMsg4OrderVo.amount || '0.00' }}
        <el-tooltip v-if="orderDeatilsData.refundMsg4OrderVo.amount" effect="light" placement="right">
          <div slot="content">
            <h5 v-for="(v,n) in orderDeatilsData.refundMsg4OrderVo.payItemList" :key="n">{{ v.payType == 1 ? '现金' : v.payType == 2 ? '银行卡' : v.payType == 3 ? '会员卡' : v.payType == 4 ? '扫码' : v.payType == 5 ? '赊账' : v.payType == 6 ? '魔盒' : v.payType == 7 ? '个人微信' : v.payType == 8 ? '个人支付宝' : v.payType == 9 ? '微信（官方）' : v.payType == 10 ? '支付宝（官方）' : v.payType == 11 ? '微信（通联）' : v.payType == 12 ? '支付宝（通联）' : v.payType == 13 ? '微信（翼支付）' : v.payType == 14 ? '支付宝（翼支付）' : v.payType == 15 ? '微信（合利宝）' : v.payType == 16 ? '支付宝（合利宝）' : v.payType == 17 ? '微信（收银宝）' : v.payType == 18 ? '支付宝（收银宝）' : '其他' }}：-￥{{ v.amount }}</h5>
          </div>
          <i class="iconfont" style="font-size: 14px;">&#xe71a;</i>
        </el-tooltip>
      </div>
    </li>
    <li>
      <div class="th">退款发起人</div>
      <div class="td">{{ orderDeatilsData.refundMsg4OrderVo.initiatorName || '--' }}</div>
    </li>
    <li>
      <div class="th">退款授权人</div>
      <div class="td">{{ orderDeatilsData.refundMsg4OrderVo.dutyName || '--' }}</div>
    </li>
    <li class="liALL">
      <div class="th thAll">其他信息</div>
      <div class="td">
        {{ orderDeatilsData.refundMsg4OrderVo.productInCount!=null ? ('已退还产品入库数量('+orderDeatilsData.refundMsg4OrderVo.productInCount+'次)') : '' }}
        {{ (orderDeatilsData.refundMsg4OrderVo.productInCount!=null && orderDeatilsData.refundMsg4OrderVo.deductRefundCount!=null) ? '，' : '' }}
        {{ orderDeatilsData.refundMsg4OrderVo.deductRefundCount!=null ? ('已返还套餐划扣次数('+orderDeatilsData.refundMsg4OrderVo.deductRefundCount+'次)') : '--' }}
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    orderDeatilsData: {
      type: Object,
      default: () => { }
    },
  },
  data() {
    return {
    };
  },
  activated() {
  },
  methods: {
  }
};
</script>
